<template lang="pug">
  .package(:class="{ 'px-5': isIndependentPackage }")
    v-row
      v-col.d-flex.align-center
        h3.primaryHover--text {{ `${$tc('Package._name', 1)} ${!isIndependentPackage ? visibleIndex + 1 : ''}` }}
        v-spacer
        template(v-if="!isIndependentPackage")
          g-btn(icon, @click="$emit('duplicate', instance)")
            v-icon.primary--text mdi-file-outline
          g-btn(icon, @click="$emit('close', instance)")
            v-icon.primary--text mdi-close
    v-row
      v-col(cols="12", sm="2")
        v-select(
          :label="$t('Package.packaging')"
          :value="instance['packaging']"
          @input="$store.commit(setInstancePathAction, { path: path + '.packaging', value: $event })"
          :items="handlingUnitsItems"
          item-text="name"
          item-value="name"
          :loading="handleUnitsLoading"
          :error-messages="errors[`packages[${elementIndex}].packaging`]"
          :disabled="isBlocked"
        )
      v-col(cols="12", sm="2")
        v-text-field(
          :label="$t('Package.caseIdentifier')"
          :value="instance['caseIdentifier']"
          @input="$store.commit(setInstancePathAction, { path: path + '.caseIdentifier', value: $event })"
          :error-messages="errors[`packages[${elementIndex}].caseIdentifier`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="1")
        v-text-field(
          :label="$t('Package.packagingLength')"
          :value="instance['packagingLength']"
          @input="$store.commit(setInstancePathAction, { path: path + '.packagingLength', value: $event })"
          type="number"
          min="0"
          :rules="[v => (v > 0) || $t('Package.packagingLengthRule')]"
          :error-messages="errors[`packages[${elementIndex}].packagingLength`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="1")
        v-text-field(
          :label="$t('Package.packagingWidth')"
          :value="instance['packagingWidth']"
          @input="$store.commit(setInstancePathAction, { path: path + '.packagingWidth', value: $event })"
          type="number"
          min="1"
          :rules="[v => (v > 0) || $t('Package.packagingWidthRule')]"
          :error-messages="errors[`packages[${elementIndex}].packagingWidth`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="1")
        v-text-field(
          :label="$t('Package.packagingHeight')"
          :value="instance['packagingHeight']"
          @input="$store.commit(setInstancePathAction, { path: path + '.packagingHeight', value: $event })"
          type="number"
          min="0"
          :rules="[v => (v > 0) || $t('Package.packagingHeightRule')]"
          :error-messages="errors[`packages[${elementIndex}].packagingHeight`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="2")
        v-select(
          :label="$t('Package.dimensionUnit')"
          :value="instance['dimensionUnit']"
          @input="$store.commit(setInstancePathAction, { path: path + '.dimensionUnit', value: $event })"
          :items="itemList('dimensionUnit')"
          :error-messages="errors[`packages[${elementIndex}].dimensionUnit`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="1")
        v-text-field(
          :label="$t('Package.packagingWeight')"
          :value="instance['packagingWeight']"
          @input="$store.commit(setInstancePathAction, { path: path + '.packagingWeight', value: $event })"
          type="number"
          min="0"
          :rules="[v => (v > 0) || $t('Package.packagingWeightRule')]"
          :error-messages="errors[`packages[${elementIndex}].packagingWeight`]"
          :disabled="isBlocked"
        )
      v-col(cols="6", sm="2")
        v-select(
          :label="$t('Package.weightUnit')"
          :value="instance['weightUnit']"
          @input="$store.commit(setInstancePathAction, { path: path + '.weightUnit', value: $event })"
          :items="itemList('weightUnit')"
          :error-messages="errors[`packages[${elementIndex}].weightUnit`]"
          :disabled="isBlocked"
        )
      v-col(cols="12", sm="2")
        v-select(
          :label="$t('Package.status')"
          :value="instance['statusId']"
          @input="setStatus"
          :items="packageStatuses"
          item-text="name"
          item-value="id"
          return-object
          :loading="statusLoading"
          :error-messages="errors[`packages[${elementIndex}].statusId`]"
          :disabled="isBlocked"
        )
    v-row
      v-col(cols="6", sm="2")
        v-text-field(
          v-if="isCrossDock"
          :label="$t('Package.consolidationKey')"
          :value="instance['consolidationKey']"
          @input="$store.commit(setInstancePathAction, { path: path + '.consolidationKey', value: $event })"
          :disabled="isBlocked"
        )
  </template>

<script>
import axios from 'axios';
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  name: "package-form",
  props: {
    extraData: {
      type: Boolean,
      default: true,
    },
    replasable: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    invert: {
      type: Boolean,
      default: true,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    selectorOnly: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    path: {
      type: String,
      default: null
    },
    parentPath: {
      type: String,
      default: null
    },
    fromList: Boolean,
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isAddEnabled: {
      type: Boolean,
      default: true
    },
    relation: null,
    elementIndex: null,
    visibleIndex: null,
    handlingUnits: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    localHandlingUnits: [],
    handleUnitsLoading: false,
    packageStatuses: [],
    statusLoading: true,
  }),
  computed: {
    errors() {
      return this.$store.state.errors;
    },
    isIndependentPackage() {
      return !this.fromList;
    },
    handlingUnitsItems() {
      return this.isIndependentPackage ? this.localHandlingUnits : this.handlingUnits;
    },
    isCrossDock() {
      const val = localStorage.getItem('GEODIS');
      return val && val.toLowerCase().includes('crossdock');
    },
    isBlocked() {
      if (this.$route.name === 'package.edit') return false;
      const status = this.packageStatuses.find(s => s.id === this.instance.statusId);
      return status && status.blockEdit === true;
    }
  },
  methods: {
    setStatus(status) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.statusId', value: status.id })
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.status', value: status })
    },
    itemList(field) {
      try {
        return ENV.ENTITIES[this.entity.name].fields[field].options;
      } catch {
        return false;
      }
    },
    async loadStatuses() {
      try {
        this.statusLoading = true;
        const endpoint = this.$fetchLoad(`Status?where[]=entity="Package"`, true);
        const res = await axios.get(endpoint, { params: { pageSize: -1 } });
        this.packageStatuses = res.data.data;
      } catch (err) {
        console.error(this.$cleanString(err));
      } finally {
        this.statusLoading = false;
      }
    }
  },
  async created() {
    if (this.isIndependentPackage) {
      try {
        this.handleUnitsLoading = true;
        const endpoint = this.$fetchLoad(`HandlingUnit?Where[]=h => h.Entity.Contains("Package") || h.Entity = null`, true);
        const res = await axios.get(endpoint, { params: { pageSize: -1 } });
        this.localHandlingUnits = res.data.data;
      } catch (err) {
        console.log(this.$cleanString(err));
      } finally {
        this.handleUnitsLoading = false;
      }
    }

    await this.loadStatuses();
  },
}
</script>
